<template>
  <section>
    <div class="catalog__category-description">
      <div class="catalog__category-subcategories" v-html="categorySubcategories" v-if="categorySubcategories !== ''"></div>
      <section v-html="categoryDescription" v-if="!onMobile"></section>
    </div>
    <div class="catalog__category-toolbar">
      <product-list-toolbar :data-source="dataSource" position="top"></product-list-toolbar>
    </div>
    <product-active-filter-list :data-source="dataSource"></product-active-filter-list>
    <product-list
      :data-source="dataSource">
    </product-list>
    <div class="catalog__category-toolbar">
      <product-list-toolbar :data-source="dataSource" position="bottom"></product-list-toolbar>
    </div>
    <div class="catalog__category-description _mobile" v-if="onMobile">
      <span class="catalog__category-title" v-text="categoryName" />
      <section v-html="categoryDescription"></section>
    </div>
  </section>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {Prop} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'CatalogCategoryView',
    components: {
      'sub-category-list': ServiceContainer().getComponent('sub-category-list'),
      'product-list': ServiceContainer().getComponent('catalog-product-list'),
      'product-list-toolbar': ServiceContainer().getComponent('catalog-product-list-toolbar'),
      'product-active-filter-list': ServiceContainer().getComponent('catalog-product-active-filter-list'),
    }
  })

  export default class extends Vue {
    @Prop() readonly categoryName: string;
    @Prop() readonly categoryId: number;
    @Prop() readonly categoryDescription: object;
    @Prop() readonly categorySubcategories: string;
    @Prop() readonly catalogData: object;
    @Prop() readonly dataSource: string;
    @Prop() readonly subCategories: Array<object>;

    private readonly smallBreakpoint: number = 768;
    private onMobile: boolean = window.outerWidth < this.smallBreakpoint;

    get sortedSubCategories() {
      return this.subCategories.sort((a, b) => {
        return a['position'] - b['position'];
      });
    }

    created() {
      this.$store.commit(`${this.dataSource}/SET_CATEGORY_ID`, this.categoryId);
      this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, this.catalogData);

      try {
        sessionStorage.setItem('last-category-url', window.location.pathname + window.location.search);
      } catch (e) {
        // sessionStorage may be unavailable
      }

      window.onpopstate = ({state}) => {
        this.$store.commit(`${this.dataSource}/SET_CATEGORY_ID`, null === state ? this.categoryId : state['categoryId']);
        this.$store.commit(`${this.dataSource}/SET_API_RESPONSE`, null === state ? this.catalogData : state['catalogData']);
      };

      history.replaceState({categoryId: this.categoryId, catalogData: this.catalogData}, document.title);
    }
  }
</script>
